import {Component, ChangeDetectionStrategy} from "@angular/core";

@Component({
  selector: "sbb-page-layout",
  templateUrl: "./page-layout.component.html",
  styleUrls: ["./page-layout.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PageLayoutComponent {}
